export default __webpack_public_path__ + "static/media/List-documentation.2909b160.md";